import { Separator } from '@wartek-id/separator'
import { Shimmer } from '@wartek-id/shimmer'

export const DatasetLoader = () => {
  return (
    <div className="flex gap-2 border-t pt-6" data-testid="div-dataset-loader">
      <div className="flex flex-col gap-2">
        <div>
          <Shimmer width={350} height={30} />
        </div>
        <div className="flex items-center gap-2">
          <Shimmer width={100} height={10} />
          <Separator
            style={{
              width: 1,
              height: 18,
            }}
          />
          <Shimmer width={80} height={10} />
          <Separator
            style={{
              width: 1,
              height: 18,
            }}
          />
          <Shimmer width={70} height={10} />
          <Separator
            style={{
              width: 1,
              height: 18,
            }}
          />
          <Shimmer width={50} height={10} />
        </div>
      </div>
    </div>
  )
}
